import gql from "graphql-tag";

export const PUBLISH_MENU_LAYOUT_MUTATION = gql`
  mutation PublishMenuLayout($input: PublishMenuLayoutInput!) {
    publishMenuLayout(input: $input) {
      statusCode
      message
      status
    }
  }
`;
